import 'normalize.css'
import '@tenthree/udn-election2020-shared-lib/dist/udn-election2020-shared-lib.min.css'
import '@/styles/app.scss'
// import 'core-js/shim'
import 'intersection-observer'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Election2020 from '@tenthree/udn-election2020-shared-lib'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// In order to prevent the browser's default behavior
// [issue] https://github.com/quasarframework/quasar/issues/1466#issuecomment-414066098
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

Vue.use(VueScrollTo)
Vue.use(Election2020)

Vue.prototype.$bus = new Vue()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
